import { Navigate } from "react-router-dom";
import { PageHeader } from "../components/PageHeader.js";
import { CopyableId } from "../components/CopyableId.js";
import { useCurrentWorkspace } from "../hooks/useWorkspaceId.js";

export const SettingsWorkspacePage = () => {
  const { workspaceId, workspaceName, workspaceSlug, isLoading } = useCurrentWorkspace();

  if (isLoading) {
    return <p className="text-sm">Loading…</p>;
  }
  if (workspaceId === null) {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <div className="admin-page-stack">
      <PageHeader
        title="General"
        description="Workspace identity and the ID used in SDKs, demo apps, and integration configuration."
      />

      <section className="admin-panel" aria-labelledby="workspace-details-heading">
        <div className="admin-panel-header">
          <h2 id="workspace-details-heading" className="admin-panel-title">
            Details
          </h2>
        </div>
        <div className="admin-panel-body-padded">
          <dl className="admin-settings-dl">
            <dt>Name</dt>
            <dd>{workspaceName ?? "—"}</dd>
            <dt>Slug</dt>
            <dd className="admin-settings-dl-mono">{workspaceSlug ?? "—"}</dd>
          </dl>
        </div>
      </section>

      <section className="admin-panel" aria-labelledby="workspace-id-heading">
        <div className="admin-panel-header">
          <h2 id="workspace-id-heading" className="admin-panel-title">
            Workspace ID
          </h2>
        </div>
        <div className="admin-panel-body-padded">
          <p className="admin-page-description" style={{ margin: "0 0 1rem" }}>
            Set as <code className="admin-mono-inline">VERITRELLIS_WORKSPACE_ID</code> in your
            environment. This value is stable for the life of the workspace.
          </p>
          <CopyableId
            id={workspaceId}
            label="Workspace ID"
            helper="Paste into .env or your app configuration (same value the API expects on permits and workspace-scoped routes)."
            buttonLabel="Copy ID"
          />
        </div>
      </section>
    </div>
  );
};
